import * as queryString from 'querystring';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import {StringParam, useQueryParam} from 'use-query-params';

import {Button, Theme, TitleSelect, TopBar} from '../../components';
import {Department} from '../../models';
import {foodTrayTemplatesActions, storeActions, storeSelectors, userSelectors} from '../../redux';
import * as GA4Utils from '../../utils/GA4Utils';

import './FrontOffice.scss';

const DepartmentSelect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {t} = useTranslation();

  const user = useSelector(userSelectors.getUserInfo);
  const stores = useSelector(storeSelectors.getStores);
  const store = useSelector(storeSelectors.getStore);
  const isLoading = useSelector(storeSelectors.isLoading);

  const [activeStoreId, setActiveStoreId] = useQueryParam('store', StringParam);

  useEffect(() => {
    if (activeStoreId) {
      dispatch(storeActions.getStore(activeStoreId));
    } else if (user?.store?.id) {
      setActiveStoreId(user.store.id);
      dispatch(storeActions.getStore(user.store.id));
    }
    if (!user?.store?.id) {
      dispatch(
        storeActions.getStoresAndDepartments({
          offset: 0,
          limit: 50,
        }),
      );
    }
  }, [activeStoreId, user]);

  useEffect(() => {
    if (stores?.length && !activeStoreId) {
      setActiveStoreId(stores[0].id);
    }
  }, [stores, activeStoreId]);

  useEffect(() => {
    dispatch(foodTrayTemplatesActions.clearFoodTrayTemplate());
  }, []);

  useEffect(() => {
    if (activeStoreId) {
      dispatch(storeActions.getStore(activeStoreId));
    }
  }, [activeStoreId]);

  const renderButton = (department: Department) => {
    return (
      <Button key={department.id} theme={Theme.SECONDARY_TRANSPARENT}
              onClickCallback={() => setDepartment(department.id)}>
        {department.departmentTemplate?.name}
      </Button>
    );
  };

  const setDepartment = (departmentId: string) => {
    GA4Utils.sendEvent('user_actions', 'set_department');
    history.push(`/template-select?${queryString.stringify({store: activeStoreId, department: departmentId})}`);
  };

  const renderLoader = i => (
    <div className='skeleton' key={`skeleton-${i}`}>
      <Skeleton height={60}/>
    </div>
  );

  return (
    <>
      <TopBar/>
      <div className='front-office'>
        <div className='content-container'>
          <h2>{t('titleSelectDepartment')}</h2>
          {stores.length ? (
            <div className='store-select'>
              <TitleSelect
                options={stores.map(s => ({value: s.id, label: s.name}))}
                value={activeStoreId}
                isLoading={isLoading}
                onChange={setActiveStoreId}
              />
            </div>
          ) : (
            <h3>{store?.name}</h3>
          )}
          <div
            className='departments'>{isLoading ? [0, 1, 2].map(renderLoader) : store?.departments?.map(renderButton)}</div>
        </div>
      </div>
    </>
  );
};

export default DepartmentSelect;
